<template>
    <div>
        <h3>Loading ......</h3>
    </div>
</template>
<script>
  export default {
    name: 'Logout',
    data(){
        return{
            
        }
    },
    mounted(){
        this.logOut()
    },
    methods: {
        logOut(){
            localStorage.clear();
            this.$router.push('/');
        }
    }  
  }
</script>